//#region Libraries
import { useState } from "react";
//#endregion
//#region Styles
import { Column, Row, SubtitleSection } from "components/styles";
import { FormFields } from "../../styles";
//#endregion
//#region Components
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import NonBusinessDaysRecords from "./components/NonBusinessDaysRecords/NonBusinessDaysRecords";
import NoRecordsMessage from "../NoRecordsMessage/NoRecordsMessage";
import Footer from "../Footer/Footer";
//#endregion
//#region Services
import { requestCreateResourceNonBusinessDay, requestDeleteResourceNonBusinessDay } from "services/settings/scheduleAdmin/aboutScheduleAdmin";
//#endregion
//#region Utils
import { INIT_FORM_NON_BUSINESS, PERIOD_DATE_FIELD } from "../constants";
import { GET_DIALOG_ERROR_NOTIFICATION_PROPS, GET_DIALOG_SAVE_PROPS, SAVE_TYPE } from "../Dialogs/constants";
import { getDatePartsByMillis, MONTHS } from "components/CustomDatePicker/utils/helpers";
import useMainContext from "utils/context/useMainContext";
import useSettingsResourceScheduleAdminContext from "views/Configuracion/SettingsResourceScheduleAdmin/context/useSettingsResourceScheduleAdminContext";
//#endregion

const NonBusinessDaysForm = ({
    filters, registerScheduleData,
    openDialogConfirmSave,
    openDialogConfirmDelete,
    openDialogErrorNotification,
    cancelRegisterSchedule
}) => {
    const mainContext = useMainContext();
    const { loadingRequest } = useSettingsResourceScheduleAdminContext();
    //#region States
    const [form, setForm] = useState({ ...INIT_FORM_NON_BUSINESS });
    //#endregion
    //#region Functions
    const clearForm = () => {
        setForm({ ...INIT_FORM_NON_BUSINESS });
    }
    const changeField = (key, value) => {
        setForm(prev => ({
            ...prev,
            [key]: value
        }));
    }
    const changeDateField = value => {
        changeField("date", value);
    }
    const changeReasonField = value => {
        changeField("reason", value);
    }
    const saveNonBusinessDay = async () => {
        loadingRequest.show("Registrando día no hábil...");
        // Creando día no hábil
        const { success, message } = await requestCreateResourceNonBusinessDay({
            ...filters.value,
            ...form
        });
        loadingRequest.hide();
        // Resolviendo petición
        if (success) {
            clearForm();
            registerScheduleData.fill();
            return;
        }
        if (message) {
            openDialogErrorNotification(GET_DIALOG_ERROR_NOTIFICATION_PROPS[message]());
            return;
        }
        if (!success) {
            mainContext.setShowDialogUnexpectedError(true);
            return;
        }
    }
    const deleteNonBusinessDay = async id => {
        loadingRequest.hide("Eliminando día no hábil...");
        // Realizando petición
        const { success, message } = await requestDeleteResourceNonBusinessDay(id);
        loadingRequest.hide();
        // Resolviendo petición
        if (success) {
            registerScheduleData.fill();
            return;
        }
        if (message) {
            openDialogErrorNotification(GET_DIALOG_ERROR_NOTIFICATION_PROPS[message]());
            return;
        }
        if (!success) {
            mainContext.setShowDialogUnexpectedError(true);
            return;
        }
    }
    const getFormattedDate = () => {
        const [year, month, dateNumber] = getDatePartsByMillis(form.date);
        return `${dateNumber} ${MONTHS[month].substring(0, 3)} ${year}`;
    }
    const triggerSave = () => {
        openDialogConfirmSave({
            props: GET_DIALOG_SAVE_PROPS[SAVE_TYPE.NON_BUSINESS_DAY](getFormattedDate()),
            saveAction: saveNonBusinessDay
        });
    }
    const completedForm = () => {
        return Boolean(
            form.date >= 0 &&
            form.reason
        ) && filters.areCompleted();
    }
    //#endregion
    const { nonBusinessDays } = registerScheduleData;
    return (
        <FormFields>
            <Row justifyContent="flex-start" width="100%">
                <CustomDatePicker
                    label="Fecha"
                    value={form.date}
                    onChange={changeDateField}
                    period={PERIOD_DATE_FIELD}
                    required />
                <CustomTextInput
                    label="Motivo"
                    placeholder="Escribe el motivo"
                    value={form.reason}
                    onChange={changeReasonField}
                    width="55%"
                    maxLength={60}
                    required />
            </Row>
            {nonBusinessDays.length === 0
                ? <NoRecordsMessage />
                : <Column marginTop="8px">
                    <SubtitleSection
                        fontWeight="bold"
                        fontSize="15px">Registros</SubtitleSection>
                    <NonBusinessDaysRecords
                        nonBusinessDays={nonBusinessDays}
                        openDialogConfirmDelete={openDialogConfirmDelete}
                        deleteNonBusinessDay={deleteNonBusinessDay} />
                </Column>}
            <Footer
                save={triggerSave}
                cancel={cancelRegisterSchedule}
                completedForm={completedForm} />
        </FormFields>
    );
}

export default NonBusinessDaysForm;